import type { ChatDoc } from '@odo/shared-ui';

// One line for previews and search: a paragraph's text runs together, blocks are space-separated.
export function quickReplyDocText(node: ChatDoc): string {
    if (node.type === 'text') return node.text ?? '';
    if (node.type === 'hardBreak') return ' ';
    const parts = (node.content ?? []).map(quickReplyDocText);
    return node.type === 'paragraph' ? parts.join('') : parts.filter(Boolean).join(' ');
}
